import { FC, useState } from 'react';

import { QuestionAnswerItem } from '../QuestionAnswerItem';
import { ThemeMode } from '@/helpers/enums';

import { ScTerms } from './styled';

interface TermsContentProps {
  termsTitle: string;
  termsText?: string;
  termsTextComponent?: JSX.Element;
}

export const Terms: FC<TermsContentProps> = ({
  termsText,
  termsTitle,
  termsTextComponent,
}) => {
  const [openTerms, setOpenTerms] = useState(false);

  return (
    <ScTerms>
      <QuestionAnswerItem
        title={termsTitle}
        description={termsText}
        descriptionComponent={termsTextComponent}
        isOpen={openTerms}
        handleOpen={() => setOpenTerms((s) => !s)}
        mode={ThemeMode.Dark}
      />
    </ScTerms>
  );
};
